/**
 * Captures #root or document.body; ignores our floating diagnostic UI if present.
 */
export async function captureDiagnosticScreenshot(): Promise<string | undefined> {
  try {
    const html2canvas = (await import('html2canvas')).default;
    const target = document.getElementById('root') ?? document.body;
    const options: Parameters<typeof html2canvas>[1] = {
      scale: Math.min(1, 1200 / Math.max(target.scrollWidth, 800)),
      useCORS: true,
      logging: false,
      ignoreElements: (element) => element.getAttribute('data-support-diagnostic-ui') === '1',
    };
    const canvas = await html2canvas(target, options);
    const dataUrl = canvas.toDataURL('image/png');
    const base64 = dataUrl.replace(/^data:image\/png;base64,/, '');
    return base64 || undefined;
  } catch {
    return undefined;
  }
}
